export default "__VITE_ASSET__Digyv0Mg__"